/* @flow */

import {api} from 'nutshell-core/api';
import type {CoreEntityType} from 'nutshell-core/types';
import capitalize from 'underscore.string/capitalize';

// This tells redux-select how to populate a list of select options asyncronously.
export function fetchOptions(collections: (CoreEntityType | 'users')[]) {
    return (query: string) => {
        return api
            .get('searchresults', {
                filter: {entityType: collections.map(capitalize)},
                q: query,
            })
            .then((response) => response.json())
            .then((json: {searchResults: ?(Object[])}) => {
                if (!json.searchResults) return;

                // $FlowFixMe upgrading Flow to v0.92.1 on web
                return json.searchResults.map((item: Object) => {
                    // Only return the keys that we need for now.
                    return {
                        avatarUrl: item.avatarUrl,
                        name: item.displayName,
                        id: item.links.entity.id,
                        initials: item.initials,
                        type: item.links.entity.type,
                        primaryInfo: item.primaryInfo,
                        relatedName: item.relatedName, // Holds user's email address (for some reason)
                        // Useful for passing around additional data with the
                        // option that isn't necessarily used in our
                        // graphql-select components
                        metaData: {
                            href: item.htmlUrlPath,
                        },
                    };
                });
            });
    };
}
